import { render, staticRenderFns } from "./Soporte.vue?vue&type=template&id=6648f537&scoped=true"
import script from "./Soporte.vue?vue&type=script&lang=js"
export * from "./Soporte.vue?vue&type=script&lang=js"
import style0 from "./Soporte.vue?vue&type=style&index=0&id=6648f537&prod&lang=scss"
import style1 from "./Soporte.vue?vue&type=style&index=1&id=6648f537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6648f537",
  null
  
)

export default component.exports